import { render, staticRenderFns } from "./Profil.vue?vue&type=template&id=1c8c3a4b&"
import script from "./Profil.vue?vue&type=script&lang=js&"
export * from "./Profil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\PROJETS\\VITISSIA\\2024\\vitissiapro\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c8c3a4b')) {
      api.createRecord('1c8c3a4b', component.options)
    } else {
      api.reload('1c8c3a4b', component.options)
    }
    module.hot.accept("./Profil.vue?vue&type=template&id=1c8c3a4b&", function () {
      api.rerender('1c8c3a4b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/Profil.vue"
export default component.exports